//const BASE_URL = 'http://172.24.21.9:9096/api';
const BASE_URL = 'https://pulseapi.sathya.in/api';
//Local
//const BASE_URL = 'https://localhost:44378/api';
//UAT
//const BASE_URL = 'http://172.24.21.9:6061/api';

export const loginApi = {
  login: `${BASE_URL}/Login/login`,
  countOfRecords: `${BASE_URL}/Login/GetCountOfRecords`,
}
export const userApi = {
  userList: `${BASE_URL}/User/UserList`,
  createUser: `${BASE_URL}/User/CreateUser`,
  updateUser: `${BASE_URL}/User/UpdateUser`,
  userById: `${BASE_URL}/User/UserById`,
  deleteUser: `${BASE_URL}/User/DeleteUser`,
};

export const reportGroupApi = {
  saveOrUpdate: `${BASE_URL}/ReportGroup/SaveOrUpdate`,
  getAll: `${BASE_URL}/ReportGroup/GetAll`,
  getById: `${BASE_URL}/ReportGroup/GetById`,
  deleteReportGroup: `${BASE_URL}/ReportGroup/Delete`,
};
export const subscriptionApi = {
  getParameters: `${BASE_URL}/subscription/parameters`,
  saveSubscription: `${BASE_URL}/subscription/save`,
  getAll: `${BASE_URL}/subscription/GetAll`,
  getById: `${BASE_URL}/subscription/GetById`,
  delete: `${BASE_URL}/subscription/Delete`,
};

export const smtpConfigApi = {
  saveSmtpConfig: `${BASE_URL}/SMTPConfig/Save`,
  getAll: `${BASE_URL}/SMTPConfig/GetAll`,
  getById: `${BASE_URL}/SMTPConfig/GetById`,
  delete: `${BASE_URL}/SMTPConfig/Delete`,
};

export const reportServerConfigApi = {
  saveReportServerConfig: `${BASE_URL}/ReportServerConfig/Save`,
  getAll: `${BASE_URL}/ReportServerConfig/GetAll`,
  getById: `${BASE_URL}/ReportServerConfig/GetById`,
  delete: `${BASE_URL}/ReportServerConfig/Delete`,
};
export const reportApi = {
  reportList: `${BASE_URL}/Report/GetReport`,
};

